<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>CALENDARIO DE ENTREGAS</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <template>
                                <v-form ref="searchProduct">
                                  <v-container>
                                    <v-row justify="space-between">
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <v-dialog
                                          ref="dialog"
                                          v-model="modalDeliveryDay"
                                          :return-value.sync="date"
                                          width="290px"
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                              v-model="dateText"
                                              label="Fecha de Apertura"
                                              readonly
                                              v-bind="attrs"
                                              v-on="on"
                                              outlined
                                              dense
                                            ></v-text-field>
                                          </template>
                                          <v-date-picker
                                            v-model="date"
                                            locale="es"
                                            scrollable
                                          >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              text
                                              color="primary"
                                              @click="modalDeliveryDay = false"
                                            >
                                              Cancel
                                            </v-btn>
                                            <v-btn
                                              text
                                              color="primary"
                                              @click="$refs.dialog.save(date)"
                                            >
                                              OK
                                            </v-btn>
                                          </v-date-picker>
                                        </v-dialog>
                                      </v-col>

                                      <v-col
                                        cols="12"
                                        md="3"
                                      >
                                        <v-btn
                                          block
                                          depressed
                                          class="white--text"
                                          color="red"
                                          @click="domwloadLabels()"
                                        >
                                          ROTULADO MOTORIZADO
                                        </v-btn>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="3"
                                      >
                                        <v-btn
                                          block
                                          depressed
                                          class="white--text"
                                          color="deep-purple"
                                          @click="domwloadLabelsForAgency()"
                                        >
                                          ROTULADO AGENCIA
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </template>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <template>
                                <v-row class="fill-height">
                                  <v-col>
                                    <v-sheet height="64">
                                      <v-toolbar
                                        flat
                                      >
                                        <v-btn
                                          outlined
                                          class="mr-4"
                                          color="grey darken-2"
                                          @click="setToday"
                                        >
                                          HOY
                                        </v-btn>
                                        <v-btn
                                          fab
                                          text
                                          small
                                          color="grey darken-2"
                                          @click="prev"
                                        >
                                          <v-icon small>
                                            mdi-chevron-left
                                          </v-icon>
                                        </v-btn>
                                        <v-btn
                                          fab
                                          text
                                          small
                                          color="grey darken-2"
                                          @click="next"
                                        >
                                          <v-icon small>
                                            mdi-chevron-right
                                          </v-icon>
                                        </v-btn>
                                        <v-toolbar-title v-if="$refs.calendar">
                                          {{ $refs.calendar.title }}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-menu
                                          bottom
                                          right
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              outlined
                                              color="grey darken-2"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <span>{{ typeToLabel[type] }}</span>
                                              <v-icon right>
                                                mdi-menu-down
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <v-list>
                                            <v-list-item @click="type = 'day'">
                                              <v-list-item-title>Día</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = 'week'">
                                              <v-list-item-title>Semana</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = 'month'">
                                              <v-list-item-title>Mes</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = '4day'">
                                              <v-list-item-title>4 días</v-list-item-title>
                                            </v-list-item>
                                          </v-list>
                                        </v-menu>
                                      </v-toolbar>
                                    </v-sheet>
                                    <v-sheet height="1000">
                                      <v-calendar
                                        ref="calendar"
                                        v-model="focus"
                                        color="primary"
                                        :events="events"
                                        :event-color="getEventColor"
                                        :type="type"
                                        @click:event="showEvent"
                                        @click:more="viewDay"
                                        @click:date="viewDay"
                                        @change="updateRange"
                                        :weekday-format="weekdayFormat"
                                        :weekday-short-format="weekdayShortFormat"
                                      ></v-calendar>
                                      <v-menu
                                        v-model="selectedOpen"
                                        :close-on-content-click="false"
                                        :activator="selectedElement"
                                        offset-x
                                      >
                                        <v-card scrollable flat>
                                          <!-- CABECERA -->
                                          <v-toolbar :color="selectedEvent.color" dark>
                                            <v-toolbar-title>
                                              {{ selectedEvent.name }} {{ selectedEvent.phone }}
                                            </v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click="selectedOpen = false">
                                              <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                          </v-toolbar>

                                          <!-- ESTADO ACTUAL -->
                                          <v-sheet
                                            class="pa-3 text-center"
                                            color="grey lighten-3"
                                          >
                                            <v-chip
                                              large
                                              :color="selectedEvent.status_color || 'grey darken-1'"
                                              dark
                                              class="font-weight-bold"
                                            >
                                              {{ selectedEvent.status_name || 'PROGRAMADO' }}
                                            </v-chip>
                                          </v-sheet>

                                          <v-card-text>

                                            <!-- RESUMEN DEL CLIENTE -->
                                            <v-container class="py-2">
                                              <v-row dense>
                                                <v-col cols="12" class="text-center">
                                                  <v-icon small class="mr-1">mdi-account</v-icon>
                                                  <strong>{{ selectedEvent.client_full_name }}</strong>
                                                </v-col>

                                                <v-col cols="12" class="text-center">
                                                  <v-icon small class="mr-1">mdi-map-marker</v-icon>
                                                  {{ selectedEvent.district_name
                                                    ? selectedEvent.address_name + ' - ' + selectedEvent.district_name
                                                    : selectedEvent.address_name }}
                                                </v-col>

                                                <v-col cols="12" class="text-center">
                                                  <v-icon small class="mr-1">mdi-calendar</v-icon>
                                                  Entrega: {{ selectedEvent.delivery_day }}
                                                </v-col>

                                                <v-col cols="12" class="text-center">
                                                  <v-icon small class="mr-1">
                                                    mdi-alert-circle-outline
                                                  </v-icon>
                                                  Pendiente: {{ formatPending(selectedEvent.pending_payment) }}
                                                </v-col>
                                              </v-row>
                                            </v-container>

                                            <v-divider class="my-3"></v-divider>

                                            <!-- ACCIONES -->
                                            <v-container>
                                              <v-row dense>
                                                <v-col cols="12">
                                                  <v-btn
                                                    block
                                                    depressed
                                                    color="blue darken-2"
                                                    class="white--text"
                                                    @click="domwloadLabels()"
                                                  >
                                                    Marcar EN RUTA
                                                  </v-btn>
                                                </v-col>

                                                <v-col cols="12" md="6">
                                                  <v-btn
                                                    block
                                                    depressed
                                                    color="green darken-1"
                                                    class="white--text"
                                                    @click="domwloadLabelsForAgency()"
                                                  >
                                                    Marcar ENTREGADO
                                                  </v-btn>
                                                </v-col>

                                                <v-col cols="12" md="6">
                                                  <v-btn
                                                    block
                                                    depressed
                                                    color="orange darken-1"
                                                    class="white--text"
                                                    @click="domwloadLabelsForAgency()"
                                                  >
                                                    Marcar NO ENTREGADO
                                                  </v-btn>
                                                </v-col>
                                              </v-row>
                                            </v-container>

                                            <v-divider class="my-4"></v-divider>

                                            <!-- PRODUCTOS -->
                                            <v-container>
                                              <v-row>
                                                <v-col cols="12">
                                                  <div class="subtitle-1 font-weight-bold mb-2">
                                                    Productos del pedido
                                                  </div>
                                                  <v-data-table
                                                    dense
                                                    :headers="productHeaders"
                                                    :items="selectedEvent.products"
                                                  />
                                                </v-col>
                                              </v-row>
                                            </v-container>

                                          </v-card-text>

                                          <!-- FOOTER -->
                                          <v-card-actions class="grey darken-2 white--text justify-center">
                                            <v-icon left small>mdi-information</v-icon>
                                            Estado actual: {{ selectedEvent.status_name || 'PROGRAMADO' }}
                                          </v-card-actions>

                                        </v-card>
                                      </v-menu>
                                    </v-sheet>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>
        </div>
      </template>

      <template>
        <v-snackbar
          v-model="snackbar"
        >
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import { Chart } from 'highcharts-vue'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'DeliveryCalendarView',
    components: {
      DefaultLayout,
      highcharts: Chart
    },
    data () {
      return {
        overlay: false,
        panel: [0, 1, 2],
        date: moment().toISOString(true).substr(0, 10),
        modalDeliveryDay: false,
        search: {
          date: null
        },
        focus: '',
        type: 'month',
        typeToLabel: {
          month: 'Mes',
          week: 'Semana',
          day: 'Día',
          '4day': '4 Días',
        },
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        colors: ['red', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        productHeaders: [
          { text: 'PRODUCTO', value: 'product_name', width: '25%' },
          { text: 'COLOR', value: 'color_name', width: '10%' },
          { text: 'TALLA', value: 'size_name', width: '10%' },
          { text: 'UNI.', value: 'quantity', width: '10%' }
        ],
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    computed: {
      dateText () {
        this.search.date = this.date;
        return this.formatDateInit(this.date);
      }
    },
    methods: {
      formatDateInit(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      formatPending(value) {
        if (!isNaN(parseFloat(value)) && isFinite(value)) {
          return `S/ ${parseFloat(value).toFixed(2)}`;
        }
        return value;
      },
      weekdayFormat({ weekday }) {
        const dias = [
          'Domingo', 'Lunes', 'Martes',
          'Miércoles', 'Jueves', 'Viernes', 'Sábado'
        ];
        return dias[weekday];
      },
      weekdayShortFormat({ weekday }) {
        const dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
        return dias[weekday];
      },
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      updateRange ({start, end}) {
        this.overlay = true;
        axios.defaults.headers = {
          'authorization': localStorage.getItem('authorization')
        };
        axios.get(process.env.DINO.PATH.GET_DELIVERIES_CALENDAR, {
          params: {
            start: start.date,
            end: end.date
          }
        }            )
        .then(response => {
          const events = [];
          for (let i = 0; i < response.data.length; i++) {

            const clientDelivery = response.data[i];
            let color = 'grey darken-1';

            if (clientDelivery.shipping_type == 'MOTORIZADO') {
              color = 'red';
            } else if (clientDelivery.shipping_type == 'ALMACEN') {
              color = 'green';
            } else if (clientDelivery.shipping_type == 'AGENCIA') {
              color = 'deep-purple';
            } else {
              color = 'grey darken-1';
            }

            events.push({
              name: `${clientDelivery.shipping_type} - ${clientDelivery.phone}`,
              start: clientDelivery.delivery_day,
              end: clientDelivery.delivery_day,
              color: color,
              timed: false,
              client_full_name: clientDelivery.client_full_name,
              address_name: clientDelivery.address_name,
              district_name: clientDelivery.district_name,
              delivery_day: this.formatDateInit(clientDelivery.delivery_day),
              products: clientDelivery.products,
              pending_payment: clientDelivery.pending_payment
            })
          }
          this.events = events;
        })
        .catch((err) => {
          console.log(err);
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      // rnd (a, b) {
      //   return Math.floor((b - a + 1) * Math.random()) + a
      // },

      domwloadLabels() {
        this.overlay = true;
        axios.post(
          process.env.DINO.PATH.DOMWLOAD_LABELS, {
            'date': this.search.date
          }, {
          responseType: 'blob'
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      domwloadLabelsForAgency() {
        this.overlay = true;
        axios.post(
          process.env.DINO.PATH.DOMWLOAD_LABELS_FOR_AGENCY, {
            'date': this.search.date
          }, {
          responseType: 'blob'
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      logout: function() {
        localStorage.clear();
        window.location.href = "/";
      }
    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.$refs.calendar.checkChange();
    }
  }
</script>
<style scoped>
  .larger-text {
    font-size: 1.2rem; /* o 1.4rem, 1.5rem según cuánto quieras */
  }
</style>



// WEBPACK FOOTER //
// src/views/order/DeliveryCalendar.vue